/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type ActionClosedReason =
  (typeof ActionClosedReason)[keyof typeof ActionClosedReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionClosedReason = {
  MANUAL: "MANUAL",
  RULE_RESOLVED: "RULE_RESOLVED",
} as const;
